/**
 * Calculates excel spreadsheet column letters.
 * @param {number} index - index from step 4 mapping representing the column index.
 * @returns {string}
 */
export const calculateColumnLetters = index => {
  const ordA = 'a'.charCodeAt(0);
  const ordZ = 'z'.charCodeAt(0);
  const len = ordZ - ordA + 1;

  let columnLetter = '';
  while (index >= 0) {
    columnLetter = String.fromCharCode((index % len) + ordA) + columnLetter;
    index = Math.floor(index / len) - 1;
  }

  return columnLetter.toUpperCase();
};
